<template>
  <el-col :span="8" style="margin-left:-2px;display:flex">
    <el-col :span="9" class="form-title">
      <sup v-if="isEdit&&formData.rfIsMust" style="color:red">*</sup>
      {{formData.rfName}}
      <el-tooltip v-if="isEdit&&formData.rfRemake!=''&&formData.rfRemake" class="item" effect="dark" :content="formData.rfRemake" placement="right">
        <i class="el-icon-question" style="margin-left:5px;color:grey"></i>
      </el-tooltip>
    </el-col>
    <el-col :span="15" class="form-value">
      <!-- 短文本 -->
      <div v-if="formData.rfType==1" ref="formText" style="padding:0 8px;" :class="{'width-100':isEdit}">
        <el-popover
          v-if="!isEdit||((formData.rfName=='企业名称'||formData.rfName=='企业类型'||formData.rfName=='所在区域')&&formData.rfIsDefault)"
          placement="top-start"
          width="200"
          trigger="hover"
          :disabled="isOverflow"
          :content="formData.cdValue">
          <div slot="reference" class="ellipsis-text" ref="popover">{{formData.cdValue|empty}}</div>
        </el-popover>
        <el-input v-else v-model="formData.cdValue" width=100></el-input>
      </div>
      <!-- 长文本 -->
      <div v-if="formData.rfType==2" ref="formText" style="padding:5px 8px;" :class="{'width-100':isEdit}">
        <el-popover
          v-if="!isEdit"
          placement="top-start"
          width="200"
          trigger="hover"
          :disabled="isOverflow"
          :content="formData.cdValue">
          <div slot="reference" class="ellipsis-text" ref="popover">{{formData.cdValue|empty}}</div>
        </el-popover>
        <el-input type="textarea" rows="1" v-else v-model="formData.cdValue" width=100></el-input>
      </div>
      <!-- 单选项/多选项 -->
      <div v-if="formData.rfType==3||formData.rfType==4" ref="formText" style="padding:0 8px;" :class="{'width-100':isEdit}">
        <el-select v-if="isEdit" v-model="formData.cdValue" clearable placeholder="请选择" :multiple="formData.rfType==4" :disabled="!isEdit">
          <el-option
            v-for="item in getOptions(formData.rfTypeNames)"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-popover
          v-if="!isEdit"
          placement="top-start"
          width="200"
          trigger="hover"
          :disabled="isOverflow"
          :content="selectOption()">
          <div slot="reference" class="ellipsis-text" ref="popover">{{selectOption()|empty}}</div>
        </el-popover>
      </div>
      <!-- 附件 -->
      <div v-if="formData.rfType==5" style="padding:0 8px;" class="width-100 file-box">
        <a v-if="formData.cdValue" :href="getFilePath()" target="_blank" class="file-style ellipsis-text" :class="{'file-edit':isEdit}">
          <i class="el-icon-document"></i>
          {{getFileName()}}
        </a>
        <p v-else>-</p>
        <!-- <p v-if="!formData.cdValue&&isEdit"><i class="el-icon-upload2"></i>上传</p> -->
        <v-file-upload :number="1" v-if="!formData.cdValue&&isEdit" @onFileChange="onFileChange(arguments)"></v-file-upload>
        <p v-if="formData.cdValue&&isEdit" @click="delFile()">删除</p>
      </div>
      <!-- 日期选择器 -->
      <div v-if="formData.rfType==6" style="padding:0 8px;" class="width-100">
        <el-date-picker
          v-if="isEdit"
          v-model="formData.cdValue"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <p v-else class="ellipsis-text">{{formData.cdValue|empty}}</p>
      </div>
    </el-col>
  </el-col>
</template>

<script>
export default {
  name: '',
  props: ['formData','isEdit'],
  components: {},
  data () {
    return {
      isOverflow: false
    }
  },

  mounted() {
    this.judgeOverflow()
    if(this.formData.rfType==4&&this.formData.cdValue!=null&&this.formData.cdValue!=""){
      this.formData.cdValue = this.formData.cdValue.split('，')
    }
  },
  watch: {
    formData: function () {
      if(this.formData.rfType==4&&this.formData.cdValue!=null&&this.formData.cdValue!=""){
        this.formData.cdValue = this.formData.cdValue.split('，')
      }
    }
  },

  methods: {
    judgeOverflow() {
      if(this.$refs['formText']){
        if(this.$refs['formText'].parentNode.clientWidth - this.$refs['popover'].clientWidth < 18){
          this.isOverflow = false
        }else{
          this.isOverflow = true
        }
      }
    },
    selectOption() {
      if(Array.isArray(this.formData.cdValue)){
        return this.formData.cdValue.join('，')
      }else{
        return this.formData.cdValue
      }
    },
    getOptions(val){
      if(val){
        let arr = val.split('$-$')
        return arr
      }
    },
    onFileChange(obj) {
      let file = {
        fileName: obj[0].fileList[0].fileName,
        filePath: obj[0].fileList[0].exportFile
      }
      this.formData.cdValue = JSON.stringify(file)
    },
    delFile(){
      this.$confirm('确认要删除该附件吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>{
        this.formData.cdValue = ''
      }).catch(()=>{
        this.$message.info('操作取消')
      })
    },
    getFilePath() {
      return JSON.parse(this.formData.cdValue).filePath
    },
    getFileName() {
      return JSON.parse(this.formData.cdValue).fileName
    }
  },
}

</script>
<style lang='scss' scoped>
.form-title{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  background: #f6faff;
  margin: 0 -1px -1px 0;
  text-align: center;
}
.form-value{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  margin: 0 0 -1px 0;
}
.ellipsis-text{
  text-align:center;
  overflow: hidden; /*隐藏溢出的文本  */
  text-overflow: ellipsis;
  word-break: break-all;/*自动换行*/
  -webkit-line-clamp:1; /*显示的行数*/
  -moz-box-orient: vertical; /*从上到下自动排列子元素*/
  -webkit-box-orient: vertical; 
  display: -webkit-box ;
  width: 100%;
}
.width-100{
  width: 100%;
}
.file-style{
  color: rgb(0, 110, 255);
  
}
.file-style:hover{
  text-decoration: underline;
  font-weight: bold;
}
.file-box{
  cursor: pointer;
  display: flex;
  justify-content: center;
  p{
    margin-left: 8px;
  }
  p:hover{
    text-decoration: underline;
    font-weight: bold;
  }
  p:hover i{
    font-weight: bold;
  }
}
.file-edit{
  width: calc(100% - 50px);
}
</style>



// WEBPACK FOOTER //
// src/components/form-input.vue